import {
    CHECK_DETAIL_GROUP_BY_KEYS,
    CheckDetailGroupBy,
} from "@common/types/reports/check-detail";
import { GroupByOption } from "@design-system/ViewTable/grouping/groupByTriggerLabel";

export const CHECK_DETAIL_GROUP_BY_VALUES: CheckDetailGroupBy[] = [
    ...CHECK_DETAIL_GROUP_BY_KEYS,
];

const CHECK_DETAIL_GROUP_BY_LABELS: Record<
    CheckDetailGroupBy,
    Omit<GroupByOption<CheckDetailGroupBy>, "key">
> = {
    bankAccount: { label: "Bank account" },
    reconciliationStatus: { label: "Reconciliation status" },
    counterparty: { label: "Counterparty" },
    none: { label: "None", triggerLabel: "No grouping" },
};

export const CHECK_DETAIL_GROUP_BY_OPTIONS: Array<
    GroupByOption<CheckDetailGroupBy>
> = CHECK_DETAIL_GROUP_BY_VALUES.map((key) => ({
    key,
    ...CHECK_DETAIL_GROUP_BY_LABELS[key],
}));
